import { merge } from "theme-ui"
import tailwind from "@theme-ui/preset-tailwind"

const theme = merge(tailwind, {
  config: {
    initialColorModeName: `light`,
  },
  fonts: {
    body: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`,
    heading: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`,
    monospace: `"SF Mono", "Fira Code", monospace`,
  },
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
  },
  colors: {
    text: `#1a1a1a`,
    primary: `#0066FF`,
    background: `#F5F5F5`,
    backgroundPattern: `#EBEBEB`,
    iconPrimary: `#1a1a1a`,
    iconSecondary: `#666666`,
    textMuted: `#666666`,
    heading: `#000000`,
    toggleIcon: `#000000`,
    muted: `#E0E0E0`,
    modes: {
      dark: {
        primary: `#4D9FFF`,
        text: `#E0E0E0`,
        background: `#121212`,
        backgroundPattern: `#1a1a1a`,
        iconPrimary: `#E0E0E0`,
        iconSecondary: `#999999`,
        textMuted: `#999999`,
        heading: `#FFFFFF`,
        toggleIcon: `#FFFFFF`,
        muted: `#333333`,
      },
    },
  },
  layout: {
    footer: {
      display: `block`,
      color: `text`,
      pt: 5,
      pb: 4,
      borderTop: `1px solid`,
      borderColor: `muted`,
      mt: 5,
    },
    main: {
      position: `relative`,
    },
    header: {
      position: `relative`,
      overflow: `hidden`,
      justifyContent: `center`,
    },
    projectHead: {
      position: `relative`,
      overflow: `hidden`,
      justifyContent: `center`,
    },
    container: {
      px: [3, 4],
      py: [2, 3],
      maxWidth: `1200px`,
    },
  },
  styles: {
    root: {
      color: `text`,
      backgroundColor: `background`,
      margin: 0,
      padding: 0,
      boxSizing: `border-box`,
      textRendering: `optimizeLegibility`,
      WebkitFontSmoothing: `antialiased`,
      MozOsxFontSmoothing: `grayscale`,
      WebkitTextSizeAdjust: `100%`,
      fontFamily: `body`,
      img: {
        borderStyle: `none`,
      },
      pre: {
        fontFamily: `monospace`,
        fontSize: `1em`,
      },
    },
    a: {
      color: `primary`,
      textDecoration: `none`,
      transition: `all 0.2s ease-in-out`,
      "&:hover": {
        textDecoration: `underline`,
      },
    },
    p: {
      fontSize: [1, 2],
      letterSpacing: `-0.01em`,
      lineHeight: 1.7,
      "--baseline-multiplier": 0.179,
      "--x-height-multiplier": 0.35,
    },
    h1: {
      fontSize: [5, 6],
      mt: 0,
      mb: 3,
      fontWeight: `heading`,
      letterSpacing: `-0.02em`,
      color: `heading`,
    },
    h2: {
      fontSize: [3, 4],
      mt: 4,
      mb: 2,
      fontWeight: `heading`,
      color: `heading`,
    },
    h3: {
      fontSize: [2, 3],
      mt: 3,
      mb: 2,
      fontWeight: `heading`,
      color: `heading`,
    },
    h4: {
      fontSize: [1, 2],
      fontWeight: `heading`,
      color: `heading`,
    },
    h5: {
      fontSize: 1,
      fontWeight: `heading`,
      color: `heading`,
    },
    h6: {
      fontSize: 1,
      mb: 2,
      fontWeight: `heading`,
      color: `heading`,
    },
  },
})

export default theme
